var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5001 9H6.5",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8334 11.5L21.3735 18.3991C21.1965 21.054 21.108 22.3815 20.243 23.1907C19.378 24 18.0476 24 15.3868 24H14.6134C11.9526 24 10.6222 24 9.75719 23.1907C8.89218 22.3815 8.80368 21.054 8.62669 18.3991L8.16675 11.5",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14L13 19",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14L17 19",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9C9.55588 9 9.58382 9 9.60915 8.99936C10.4326 8.97849 11.159 8.45491 11.4392 7.68032C11.4478 7.65649 11.4567 7.62999 11.4743 7.57697L11.5714 7.28571C11.6543 7.03708 11.6957 6.91276 11.7507 6.8072C11.97 6.38607 12.3757 6.09364 12.8446 6.01877C12.9621 6 13.0932 6 13.3553 6H16.6447C16.9068 6 17.0379 6 17.1554 6.01877C17.6243 6.09364 18.03 6.38607 18.2493 6.8072C18.3043 6.91276 18.3457 7.03708 18.4286 7.28571L18.5257 7.57697C18.5433 7.62992 18.5522 7.65651 18.5608 7.68032C18.841 8.45491 19.5674 8.97849 20.3909 8.99936C20.4162 9 20.4441 9 20.5 9",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.8be12f01f67aaefa0b04bcfc8b7999e5.svg";
export { ForwardRef as ReactComponent };